import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

export interface ShipmentMaster {
  ShipmentMasterOrderNo: number;
  ModelName: string;
  ModelCode: string;
  ModelGroup: string;
  Classification: string | null;
  OccNo: string | null;
  ExtColourCode: string | null;
  ExtColourType: string | null;
  IntColourCode: string | null;
  IntColourType: string | null;
  Quantity: number | null;
  ReceivedQuantity: number | null;
  EntryDate: string;
  ArrivalDate: string;
  OrdersRemark: string | null;
  EtaRemark: string | null;
}

export interface ShipmentUpdateRequest {
  OrderNoList: number[];
  Value: string;
}

@Injectable({ providedIn: "root" })
export class ShipmentMasterService {
  private readonly baseUrl = "ShipmentMasterService.asmx";

  constructor(private http: HttpUtilService) {}

  getShipmentEntryDates(): Observable<HttpResponse<string[]>> {
    return this.http.get<string[]>(`${this.baseUrl}/GetShipmentEntryDates`);
  }

  getBasicActiveModelList(): Observable<HttpResponse<any[]>> {
    return this.http.get<any[]>("ModelSpecificationService.asmx/GetBasicActiveModelList");
  }

  getColourCodeByModel(
    modelGroup: string,
    modelDescription: string,
  ): Observable<HttpResponse<any[]>> {
    return this.http.get<any[]>(
      `ColourMasterService.asmx/GetColourCodeByModel?modelGroup=${encodeURIComponent(JSON.stringify(modelGroup))}&modelCode=${encodeURIComponent(JSON.stringify(modelDescription))}`,
    );
  }

  getIntColourCodeList(
    modelDescription: string,
    exteriorColourCode: string,
  ): Observable<HttpResponse<any[]>> {
    return this.http.get<any[]>(
      `ColourMasterService.asmx/GetIntColourCodeList?model=${encodeURIComponent(JSON.stringify(modelDescription))}&extColour=${encodeURIComponent(JSON.stringify(exteriorColourCode))}`,
    );
  }

  addShipment(modelList: ShipmentMaster[]): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.baseUrl}/Add`, { modelList });
  }

  getAllShipmentByDate(date: string): Observable<HttpResponse<ShipmentMaster[]>> {
    return this.http.get<ShipmentMaster[]>(
      `${this.baseUrl}/GetAllShipmentByDate?date=${encodeURIComponent(JSON.stringify(date))}`,
    );
  }

  getShipmentDetails(shipmentCode: number): Observable<HttpResponse<ShipmentMaster>> {
    return this.http.get<ShipmentMaster>(
      `${this.baseUrl}/GetDetails?shipmentCode=${encodeURIComponent(JSON.stringify(shipmentCode))}`,
    );
  }

  updateRemarks(model: ShipmentUpdateRequest): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.baseUrl}/UpdateRemarks`, { model });
  }

  updateArrivalDate(model: ShipmentUpdateRequest): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.baseUrl}/UpdateArrivalDate`, { model });
  }

  deleteShipment(id: number): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.baseUrl}/Delete`, { id });
  }

  updateShipment(model: ShipmentMaster): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.baseUrl}/Update`, { model });
  }
}
